import React, { useEffect, useContext, useReducer } from 'react';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';
import { ThemeProvider } from 'emotion-theming';
import GlobalContext from '../../context/global';
import globalReducer from '../../reducers/global';
import { setLoggedInUser, setLocation } from '../../actions/global';
import Theme from '../Theme';
import GlobalStyles from '../Theme/styles';
import Navigation from '../Navigation';
import MaintenanceNavigation from '../Navigation/MaintenanceNavigation';
import Footer from '../Footer';
import MaintenanceFooter from '../Footer/MaintenanceFooter';
import { StyledSiteContent, StyledSiteWrapper } from './styles';
import '../../assets/styles/style.scss';

const theme = {
  ...Theme,
};

const SiteLayout = ({ location, children, isMaintenance, showHomeBanner }) => {
  const initialState = useContext(GlobalContext);
  const [state, dispatch] = useReducer(globalReducer, {
    ...initialState,
    location: location || {},
  });

  useEffect(() => {
    if (window.location === 'undefined') return;

    setLocation(location, dispatch);

    const makoToken = Cookies.get('mako_auth_token');
    const getUser = async () => {
      if (makoToken) {
        const response = await fetch(
          'https://api.sendgrid.com/v3/user/profile',
          {
            headers: { Authorization: `token ${makoToken}` },
          }
        );
        const userData = await response.json();
        setLoggedInUser(userData, dispatch);
      }
    };
    getUser();
  }, []);

  return (
    <GlobalContext.Provider value={{ ...state, dispatch }}>
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        <StyledSiteWrapper>
          {isMaintenance ? <MaintenanceNavigation /> : <Navigation showHomeBanner={showHomeBanner} path={location.pathname} />}
          <StyledSiteContent>
            <main>{children}</main>
            {isMaintenance ? <MaintenanceFooter /> : <Footer />}
          </StyledSiteContent>
        </StyledSiteWrapper>
        <div id="teconsent" style={{display: 'none'}} />
      </ThemeProvider>
    </GlobalContext.Provider>
  );
};

SiteLayout.propTypes = {
  children: PropTypes.node.isRequired,
  isMaintenance: PropTypes.bool,
};

SiteLayout.defaultProps = {
  isMaintenance: false,
};

export default SiteLayout;
